
import { ILookUp } from '@/models/main';
import { ISelectSuburb } from '@/models/jbAdvanced';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

/**
 * Autocomplete component to lookup Customer code
 * @property stop unknown prop
 * @property focus enable v-autocomplete autofocus
 * @property chosen unknown prop
 * @property tabIndex unknown prop
 */
@Component({})
export default class LookupCustomerCode extends Vue {
  //TODO: if required false and exclamation mark is set why there is no default values???
  @Prop({ type: Number, required: false }) private readonly stop!: number;
  @Prop({ type: Boolean, required: false }) public readonly focus!: boolean;
  @Prop({ type: Boolean, required: false }) public readonly disabled!: boolean;
  @Prop({ type: Boolean, required: false }) public readonly required!: boolean;
  @Prop({ type: String, required: false }) private readonly chosen!: string;
  @Prop({ type: Number, required: false }) public readonly tabIndex!: number;
  @Prop({ type: Function, required: true }) private autocomplete!: (params: ILookUp) => Promise<ISelectSuburb[]>;

  public input = '';
  public inputVal = '';
  public itemSearch: ISelectSuburb[] = [];
  public loading = false;

  @Watch('chosen')
  private changeChosen() {
    if (this.chosen === '') {
      this.input = '';
    } else {
      const params: ILookUp = {
        dates: '',
        driver_id: '',
        service_code: '',
        customer_code: this.chosen,
      };
      this.autocomplete(params)
        .then(data => {
          this.itemSearch = data;
          this.change(this.chosen);
        })
        .catch(e => console.log(e))
        .finally(() => {
          this.loading = false;
        });
    }
  }

  public search(val: string) {
    if (val === this.input) {
      return;
    }
    this.inputVal = val;
    if (val?.length >= 1) {
      this.itemSearch = [];
      this.loading = true;
      const params: ILookUp = {
        dates: '',
        driver_id: '',
        service_code: '',
        customer_code: val,
      };
      this.autocomplete(params)
        .then(data => {
          this.itemSearch = data;
        })
        .catch(e => console.log(e))
        .finally(() => {
          this.loading = false;
        });
    }
  }
  public change(val) {
    this.input = val;
    if (this.itemSearch.indexOf(val) > -1) {
      this.inputVal = val;
      if (this.stop) {
        this.$emit('change', val);
      } else {
        this.$emit('change', val);
      }
    } else {
      this.input = '';
      if (this.stop) {
        this.$emit('clear', this.stop);
      } else {
        this.$emit('clear');
      }
    }
  }

  public blur() {
    if (this.input !== this.inputVal && this.inputVal && this.inputVal.length > 0) {
      this.input = '';
      if (this.stop) {
        this.$emit('clear', this.stop);
      } else {
        this.$emit('clear');
      }
    }
  }
}
